import Head from "next/head";
import { NextPage } from "next";
import { Post } from "mlp-sdk";
import navData from "@constants/navData.json";
import pageData from "@constants/pageData.json";
import { blogTagMapping } from "mlp-sdk/constants/blogs";
import useOriginURL from "mlp-sdk/hooks/useOriginURL";
import { useRouter } from "next/router";
import { useEffect } from "react";

const NEXT_PUBLIC_BLOGS_KEY = process.env.NEXT_PUBLIC_BLOGS_KEY;

const PageHead = ({ page }: any) => {
  const router = useRouter();
  const originURL = useOriginURL();
  const post = page?.data?.postData?.posts[0];
  const tag = post?.tags[0]?.slug;
  useEffect(() => {
    if (tag && blogTagMapping[tag]) {
      router.replace(`/${tag}/${post.slug}/`);
    }
  }, [tag]);
  return (
    <>
      {tag && blogTagMapping[tag] ? (
        <Head>
          <meta name="robots" content="noindex, follow" />
          <meta
            httpEquiv="Refresh"
            content={`${originURL}/${tag}/${post.slug}/`}
          />
        </Head>
      ) : (
        <Post page={page} tagPage />
      )}
    </>
  );
};

const PostPage: NextPage = ({ page }: any) => {
  return <PageHead page={page} />;
};

const fetchPostData = async (slug: string) => {
  try {
    let res: any = await fetch(
      `https://www.staderlabs.com/blog/ghost/api/content/posts/slug/${slug}?key=${NEXT_PUBLIC_BLOGS_KEY}&include=authors,tags`
    );
    res = await res.json();
    return res;
  } catch (e: any) {
    return {
      posts: [],
      meta: {
        pagination: {
          page: 1,
          pages: 1,
        },
      },
    };
  }
};

const fetchAllIds = async () => {
  let res: any = await fetch(
    `https://www.staderlabs.com/blog/ghost/api/content/posts/?key=${NEXT_PUBLIC_BLOGS_KEY}&limit=2000&fields=slug&include=tags`
  );
  res = await res.json();
  return res.posts;
};

export async function getStaticPaths() {
  const idList: any = await fetchAllIds();
  let paths = idList.map((post: any) => {
    return {
      params: {
        tag: post.slug,
      },
    };
  });
  paths = paths.filter(
    (path: any) => blogTagMapping[path.params.tag] === undefined
  );
  return { paths, fallback: true };
}

export async function getStaticProps({ params }: any) {
  const { tag } = params;
  let filteredSlug = tag.split("/");
  filteredSlug = filteredSlug[filteredSlug.length - 1];
  const [postRes] = await Promise.all([fetchPostData(filteredSlug)]);
  return {
    props: {
      page: {
        data: {
          postData: postRes,
          navData,
          pageData,
        },
      },
    },
  };
}

export default PostPage;
